import { GetterTypesFromUser } from '@/app/data-flow/user';

// eslint-disable-next-line import/prefer-default-export
export const GetterTypes = {
  GET_PATH: 'GET_PATH',
  GET_PARAMS: 'GET_PARAMS',
  GET_ROUTER_NAME: 'GET_ROUTER_NAME',
  ...GetterTypesFromUser,
};
